import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { ulGtpDataVolumeNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the UlGtpDataVolumeNrCell component
 */
interface UlGtpDataVolumeNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Uplink GTP Data Volume Chart (NR Cell Level)
 * 
 * Displays uplink S1-U GTP data volume in GB for individual NR cells.
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (ulGtpDataVolumeNrCellChartConfig)
 * @see API: /api/nr/cell/ul-gtp-data-volume?cell_name={cellName}
 */

const UlGtpDataVolumeNrCell: React.FC<UlGtpDataVolumeNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={ulGtpDataVolumeNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default UlGtpDataVolumeNrCell;
